import { ca } from '@cian/analytics';
import { EServiceId } from '../../../../redux/reducers';
import { IAnalyticsProduct, TAnalyticsOfferStatus } from '../../../../types/analytics';

interface ITrackServicesShowParams {
  analyticsOfferStatus: TAnalyticsOfferStatus;
  analyticsProduct: IAnalyticsProduct;
  serviceIds: Array<EServiceId>;
  activeServiceId: EServiceId;
  bet: number | null;
  offerPosition: number | null;
  page: number | null;
  analyticsFormId: string;
}

export const trackServicesShow = (params: ITrackServicesShowParams) => {
  const {
    analyticsOfferStatus,
    analyticsProduct,
    serviceIds,
    offerPosition,
    page,
    bet,
    activeServiceId,
    analyticsFormId,
  } = params;

  ca('eventSite', {
    name: 'oldevent',
    category: analyticsOfferStatus,
    action: 'publish_terms_block_show',
    label: serviceIds.join('/'),
    products: [analyticsProduct],
    page: {
      pageType: 'AddForm',
      extra: {
        type: 'fvu_newest',
        vas: activeServiceId,
        bid: bet,
        position: offerPosition,
        page_number: page,
        form_id: analyticsFormId,
      },
    },
  });
};

interface ITrackSliderScrollParams {
  analyticsOfferStatus: TAnalyticsOfferStatus;
  analyticsProduct: IAnalyticsProduct;
  direction: string;
  analyticsFormId: string;
}

export const trackSliderScroll = (params: ITrackSliderScrollParams) => {
  const { analyticsOfferStatus, analyticsProduct, direction, analyticsFormId } = params;

  ca('eventSite', {
    name: 'oldevent',
    category: analyticsOfferStatus,
    action: 'publish_terms_block_scroll',
    label: direction,
    products: [analyticsProduct],
    page: {
      pageType: 'AddForm',
      extra: {
        type: 'fvu_newest',
        form_id: analyticsFormId,
      },
    },
  });
};

interface ITrackDiffPricingShowParams {
  analyticsOfferStatus: TAnalyticsOfferStatus;
  analyticsFormId: string;
  diffPriceIterationId: string | null;
  diffPriceGranuleGuid: string | null;
}

export const trackDiffPricingShow = (params: ITrackDiffPricingShowParams) => {
  const { analyticsOfferStatus, analyticsFormId, diffPriceIterationId, diffPriceGranuleGuid } = params;

  ca('eventSite', {
    name: 'oldevent',
    category: analyticsOfferStatus,
    action: 'show_diff_pricing',
    page: {
      pageType: 'AddForm',
      extra: {
        type: 'fvu_newest',
        form_id: analyticsFormId,
        diffPriceGranuleGuid,
        diffPriceIterationId,
      },
    },
  });
};
